import React, {useEffect, useState} from "react";
import {Box, Divider, Fab, Paper, Typography} from "@mui/material";
import {useDispatch, useSelector} from "react-redux";
import {AppState} from "../../store";
import {formatCustomDate, NO_DATA} from "../../shared/utils";
import {getLegalCaseAction} from "../../api/legalCase";
import {AddNoteLegalCasePopup} from "../legal-case-actions/legal-case-actions";
import AddIcon from "@mui/icons-material/Add";

export interface LegalCaseDetailsProps {
    id: number;
}

export const LegalCaseNotes: React.FC<LegalCaseDetailsProps> = ({id}) => {
    const dispatch: any = useDispatch();
    const legalCase = useSelector((state: AppState) => state.legalCase.legalCase);
    const notes = legalCase?.notes;
    const [isAddNoteOpen, setAddNoteOpen] = useState(false);

    const handleAddNote = () => {
        setAddNoteOpen(true);
    };

    const handleCloseAddNote = () => {
        setAddNoteOpen(false);
        dispatch(getLegalCaseAction(id));
    };

    useEffect(() => {
        dispatch(getLegalCaseAction(id));
    }, [id, dispatch]);

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    p: 1,
                    m: 1,
                    borderRadius: 1,
                }}>
                <Fab
                    size="small"
                    color="primary"
                    aria-label="add"
                    sx={{marginLeft: "auto", marginBottom: 7}}
                    onClick={handleAddNote}>
                    <AddIcon/>
                </Fab>
            </Box>
            <Paper elevation={3} sx={{p: 3, mt: 2}}>
                {isAddNoteOpen && legalCase && (
                    <AddNoteLegalCasePopup
                        legalCase={legalCase}
                        onClose={handleCloseAddNote}
                        onAddNoteLegalCase={handleCloseAddNote}/>
                )}
                {notes && notes.length > 0
                    ? notes.map((note: any, idx: number) => (
                        <Box key={idx} sx={{mb: 2}}>
                            <Typography variant="body1" sx={{wordBreak: "break-word"}}>
                                {note.note || NO_DATA}
                            </Typography>
                            <Box sx={{display: "flex", justifyContent: "flex-end"}}>
                                <Typography variant="caption" color="text.secondary">
                                    {note.userFullName || NO_DATA}
                                    {note.date ? `, ${formatCustomDate(note.date, "DD-MM-YYYY HH:mm:ss")}` : ""}
                                </Typography>
                            </Box>
                            {idx < notes.length - 1 && (
                                <Divider sx={{mt: 1, mb: 1}}/>
                            )}
                        </Box>
                    ))
                    : (
                        <Typography align="center">Not Bulunamadı</Typography>
                    )}
            </Paper>
        </>
    );
};
